/**
 * @voltxampere/ui — Node (Düğüm) · 4-pin compass cross
 *
 * Junction marker. Four visible stubs (N/S/E/W) meeting at a
 * brass-hot dot. Sprint 11 canvas snaps three-or-more wires
 * together at this point; the cross silhouette signals "wires
 * meet here, not a crossover" without committing to which sides
 * actually carry signal.
 *
 * Sprint 25 R3 lane 6 — pin layout corrected to match the schema
 * canonical wire-node definition (4-pin n/s/e/w per
 * `packages/components/src/types/wire-node.ts:18-22`). The Sprint
 * 11 placeholder shipped 3 stubs (left / right / top); the missing
 * south stub left rotation 180° users with no top-down hit-test
 * affordance and silently reordered preset pin coords when the
 * helper's 4-pin layout (Lane 4D-A) was reconciled with the symbol's
 * 3-pin geometry.
 *
 * Pin world coords are computed by the rotation-aware helper in
 * `packages/presets/src/_layout-helpers.ts`; the symbol just
 * declares the local viewBox positions.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_BRASS_HOT, STROKE_IVORY, STROKE_WIDTH_HEAVY, VIEWBOX_DEFAULT, } from "./constants.js";
export const node = {
    id: "node",
    nameTr: "Düğüm",
    nameEn: "Node Junction",
    shortcut: "·",
    category: "connector",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "W", polarity: "bi" },
        { x: 40, y: 13, label: "E", polarity: "bi" },
        { x: 20, y: 0, label: "N", polarity: "bi" },
        { x: 20, y: 26, label: "S", polarity: "bi" },
    ],
    renderSVG: () => [
        // West stub.
        `<line x1="0" y1="13" x2="20" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        // East stub.
        `<line x1="20" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        // North stub.
        `<line x1="20" y1="0" x2="20" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        // South stub (Sprint 25 R3 lane 6 addition).
        `<line x1="20" y1="13" x2="20" y2="26" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        // Center dot — brass-hot accent so the junction reads at low
        // zoom even when the stubs blend into adjacent wires.
        `<circle cx="20" cy="13" r="2.8" fill="${STROKE_BRASS_HOT}"/>`,
    ].join(""),
};
//# sourceMappingURL=node.js.map